<template>
    <component
        :is="customTag ? customTag : 'div'"
        ref="emergencyphone"
        class="emergencyphone"
        :class="customClass"
        :data-phone="getProp('deha.user.misc.emergency.phone')"
        :data-visible="getProp('deha.user.misc.emergency.visible')"
        :data-openingtimes="
            encodeURIComponent(JSON.stringify(getProp('deha.user.misc.openingtimes')))
        "
    >
        Notruf:
        <a
            :href="'tel:' + getProp('deha.user.misc.emergency.phone')"
            class="module__link--underlined"
            >{{ getProp('deha.user.misc.emergency.phone') }}</a
        >
    </component>
</template>

<script>
import { mapGetters } from 'vuex';
import EmergencyPhone from '@/external/assorted/EmergencyPhone';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'editorMode'])
    },
    created() {},
    mounted() {
        if (this.editorMode) {
            let i = new EmergencyPhone();
            i.init(this.$refs.emergencyphone);
        }
    },
    updated() {
        if (this.editorMode) {
            let i = new EmergencyPhone();
            i.init(this.$refs.emergencyphone);
        }
    },
    props: {
        customTag: String,
        customClass: String
    }
};
</script>
